import * as React from "react";
import { Button } from "../../../ui/components/Button";
import * as authText from "../../../ui/components/Auth/authTypography.style.css";
import { OtpInputs, useOtpState } from "./verification-inputs";
import { useI18n } from "../../lib/i18n";

export function EmailCodeEntry({
  email,
  onVerify,
  onCancel,
  verifyLabel,
  expandAsCta = false,
}: {
  email: string;
  onVerify: (code: string) => void;
  onCancel?: () => void;
  verifyLabel?: string;
  /** When true, collapsed state uses a primary full-width button instead of a text link. */
  expandAsCta?: boolean;
}) {
  const { t, tx } = useI18n();
  const computedVerifyLabel = verifyLabel ?? t("account.emailCode.verify");
  const [expanded, setExpanded] = React.useState(false);
  const submitRef = React.useRef<HTMLButtonElement>(null);
  const otp = useOtpState({ submitRef });

  const handleVerify = () => {
    if (otp.code.length !== 6) return;
    onVerify(otp.code);
  };

  if (!expanded) {
    if (expandAsCta) {
      return (
        <Button
          type="button"
          color="primary"
          variant="solid"
          fullWidth
          size="lg"
          onClick={() => setExpanded(true)}
        >
          {tx("account.emailCode.enterCode")}
        </Button>
      );
    }
    return (
      <button type="button" className={authText.skipStepLink} onClick={() => setExpanded(true)}>
        {tx("account.emailCode.haveCode")}
      </button>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, width: "100%" }}>
      <OtpInputs
        digits={otp.digits}
        refs={otp.refs}
        onInput={otp.handleInput}
        onKey={otp.handleKey}
        onPaste={otp.handlePaste}
      />
      <Button
        ref={submitRef}
        color="primary"
        variant="solid"
        fullWidth
        disabled={otp.code.length !== 6}
        onClick={handleVerify}
      >
        {computedVerifyLabel}
      </Button>
      <button
        type="button"
        className={authText.textButton}
        onClick={() => {
          setExpanded(false);
          otp.reset();
          onCancel?.();
        }}
      >
        {tx("shared.common.cancel")}
      </button>
    </div>
  );
}
